// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3ZQl8bgfR5rr1Osi9SXUNM{display:flex;flex-direction:column;padding:3.2rem 2.4rem}._3sbz5uo0jCxqCRFtcij-Cg,._38NMFo5eOp-SOgQMINLR2X{flex-basis:45%}.HEp1lQMjEotwkonHwfUiF{margin-top:3rem}@media (min-width:768px){._3ZQl8bgfR5rr1Osi9SXUNM{flex-direction:row;justify-content:space-between}}@media (min-width:1200px){._3ZQl8bgfR5rr1Osi9SXUNM{flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_3ZQl8bgfR5rr1Osi9SXUNM",
	"charactesticsBloc": "_3sbz5uo0jCxqCRFtcij-Cg",
	"statsWrapper": "_38NMFo5eOp-SOgQMINLR2X",
	"stats": "HEp1lQMjEotwkonHwfUiF"
};
module.exports = ___CSS_LOADER_EXPORT___;
